import { permissionCreate } from '@permissions';

const clickOnTheCell = permissionCreate('SUMMARY_CLICK_ON_THE_CELL');

export const SUMMARY = {
  [clickOnTheCell]: clickOnTheCell,
};

export default SUMMARY;
